import React from 'react';
import Loading from '../Loading'

const LoginLoading = ({ className }) => {
    return (
        <Loading style={{
            width: '60px',
        height:'60px',
        background: 'rgba(256,256,256,0.9)',
        padding: '0px',
        alignItems: 'center',
        borderRadius: '4px',
        }}
        className={className}
        ></Loading>
    )
}

export default LoginLoading
